import Dagre from '@dagrejs/dagre';

const graph = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));

const getLayoutedElements = (nodesForLayout, edgesForLayout, options) => {
  const isHorizontal = options.direction === 'LR';

  graph.setGraph({ rankdir: options.direction });

  edgesForLayout.forEach(edge => graph.setEdge(edge.source, edge.target));
  nodesForLayout.forEach(node => graph.setNode(node.id, node));

  Dagre.layout(graph);

  return {
    nodes: nodesForLayout.map(node => {
      const nodeWithPosition = graph.node(node.id);
      node.targetPosition = isHorizontal ? 'left' : 'top';
      node.sourcePosition = isHorizontal ? 'right' : 'bottom';

      const x = nodeWithPosition.width
        ? nodeWithPosition.x - nodeWithPosition.width / 2
        : nodeWithPosition.x;
      const y = nodeWithPosition.width
        ? nodeWithPosition.y - nodeWithPosition.height / 2
        : nodeWithPosition.y;

      return { ...node, position: { x: x, y: y } };
    }),
    edges: edgesForLayout,
  };
};

const flowChartUtils = {
  getLayoutedElements: getLayoutedElements,
};

export { flowChartUtils };
